import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';
import { ResumoMensal } from './ResumoMensal';
import { initializePageAction } from '../../../store/theme.actions';

function ResumoMensalPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Resumo Mensal'));
  return (
    <ResumoMensal />
  );
}

export default withTokenInterceptor(ResumoMensalPage);
